import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { Tooltip } from 'coreOld/components';
import { Icon } from 'coreOld/elements';
import { Position } from 'coreOld/enums';
import { PricingHelper } from 'coreOld/helpers';
import { CorporatePartCostStatus } from 'corporate/enums';

interface IProps {
  costStatus: CorporatePartCostStatus;
  showWarningTooltip?: boolean;
}

const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.dangerNt};
  margin-left: 5px;
`;

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  width: 100%;
  font:
    400 14px 'Open Sans',
    sans-serif;
  letter-spacing: 0;
`;

const BorderBottom = styled.div`
  position: absolute;
  border-bottom: 5px solid ${({ theme }) => theme.colors.dangerNt};
  bottom: 0px;
  left: 15px;
  right: 15px;
`;

const iconStyle = {
  fontSize: 16,
};

const CostWarning = ({ costStatus, showWarningTooltip = true }: IProps) => {
  const theme = useTheme() as any;

  const { t } = useTranslation();

  if (PricingHelper.isCostingValidByStatus(costStatus)) {
    return <></>;
  }

  const tooltipText = <TooltipContent>{t('errorInvalidCost')}</TooltipContent>;

  return (
    <Wrapper>
      {showWarningTooltip && (
        <Tooltip
          text={tooltipText}
          position={Position.RIGHT}
          tooltipOpacity={1}
          backgroundColor={theme.colors.dangerNt}
        >
          <Icon name={Icon.EXCLAMATION_TRIANGLE} style={iconStyle} />
        </Tooltip>
      )}

      {!showWarningTooltip && (
        <Icon name={Icon.EXCLAMATION_TRIANGLE} style={iconStyle} hover={false} />
      )}

      <BorderBottom />
    </Wrapper>
  );
};

export default CostWarning;
